module.exports = __webpack_public_path__ + "img/info-button-grey.f83bacbe.svg";